import { useState } from "react";
import { useMutation } from "@apollo/client";
import { App } from "antd";
import { useTranslation } from "react-i18next";
import { SIGN_IN } from "./signIn.gql";
import { API_URL, COOKIE_URL } from "../../constants/app";
import { setUser } from "../../store/slices/user";
import { useAppDispatch } from "../../store";

const SignIn = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const dispatch = useAppDispatch();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [signIn, { loading }] = useMutation(SIGN_IN, {
    fetchPolicy: "no-cache",

    onCompleted(data) {
      if (data.login.id) {
        dispatch(setUser(data.login));
      }
    },
    onError(error) {
      message.error(error.graphQLErrors[0].message);
    }
  });

  const onFinish = async (values: any) => {
    await fetch(`${API_URL}${COOKIE_URL}`, {
      method: "GET",
    }).then(() => {
      signIn({
        variables: {
          email: values.username,
          password: values.password
        }
      });
    })
      .catch(() => {
        message.error(t("global.error.token"));
      });
  };

  return {
    onFinish,
    loading,
    passwordVisible,
    setPasswordVisible
  };
};

export default SignIn;
